import { Country } from '@typings/entities/Country'
import toSelectOption from './toSelectOption'

const getCountryOptions = (countries: Country[]) => countries.map(toSelectOption('code', 'name'))

export default getCountryOptions
